import request from '../request';

/** 获取收货地址 */
export async function getAddressList(
  params: Pick<API.PageInfo, 'pageIndex' | 'pageSize'> & {
    contactName?: string;
    contactTel?: string;
    retailersName?: string;
    shopName?: string;
  },
) {
  return request<API.CommonPageInfoResponse<API.CustomerAddress[]>>({
    url: '/api/mall/rest/member/customer/mall/address/query/page',
    method: 'POST',
    headers: { authLogin: true },
    data: params,
  });
}

/** 新增收货地址 */
export async function createAddress(params: API.CustomerAddress) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/member/customer/mall/address/insert',
    method: 'POST',
    headers: { authLogin: true },
    data: params,
  });
}

/** 编辑收货地址 */
export async function updateAddress(params: API.CustomerAddress) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/member/customer/mall/address/update',
    method: 'POST',
    headers: { authLogin: true },
    data: params,
  });
}

/** 获取自提信息 */
export async function getSelfPickList(params: API.PageInfo) {
  return request<API.CommonResponse<API.PageInfoCustomerSelfPickInfoVO>>({
    url: '/api/mall/rest/member/customer/mall/selfpick/query/page',
    method: 'POST',
    headers: { authLogin: true },
    data: params,
  });
}

/** 新增自提信息 */
export async function createSelfPick(params: API.CustomerSelfPickInfoVO) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/member/customer/mall/selfpick/insert',
    method: 'POST',
    headers: { authLogin: true },
    data: params,
  });
}

/** 编辑自提信息 */
export async function updateSelfPick(params: API.CustomerSelfPickInfoVO) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/member/customer/mall/selfpick/update',
    method: 'POST',
    headers: { authLogin: true },
    data: params,
  });
}
